module.exports = __webpack_public_path__ + "svg/new-nordea-epayment.13c70c3d69d1695ec2f67a36faface96.svg";